var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12ZM5 4l5 3-5 3V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 7 .257.429.715-.429-.715-.429L10 7ZM5 4l.257-.429-.757-.454V4H5Zm0 6h-.5v.883l.757-.454L5 10Zm7.5-3A5.5 5.5 0 0 1 7 12.5v1A6.5 6.5 0 0 0 13.5 7h-1ZM7 1.5A5.5 5.5 0 0 1 12.5 7h1A6.5 6.5 0 0 0 7 .5v1ZM1.5 7A5.5 5.5 0 0 1 7 1.5v-1A6.5 6.5 0 0 0 .5 7h1ZM7 12.5A5.5 5.5 0 0 1 1.5 7h-1A6.5 6.5 0 0 0 7 13.5v-1Zm3.257-5.929-5-3-.514.858 5 3 .514-.858Zm-5 3.858 5-3-.514-.858-5 3 .514.858ZM4.5 4v6h1V4h-1Z"
  }))));
};
export default SvgVideo;